/*eslint-disable */
import axios from "axios";
import * as types from "../types/shipmentTypes";
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "./alertAction";
import ReadAxios from "../../components/axiosComponent/read";
const baseApi = process.env.REACT_APP_TA_API_URL;

/** Order region start */


export const readOrders = (orders) => {
  return {
    type: types.ORDER_READ,
    orders,
  };
};


// read all Orders
export function readOrderDispatcher() {
  return (dispatch) => {
    ReadAxios({ completeURL: `${baseApi}/orders` })
      .then((res) => {
        dispatch(readOrders(res.data));
        return new Promise(function (resolve) {
          resolve(res.data);
        });
      })
      .catch((err) => {
        dispatch(readOrders([]));
        return new Promise(function (resolve) {
          resolve([]);
        });
      });
  };
}
